import { useEffect, useState } from "react";
import axios from "axios";
import { Camera, Loader2, RotateCw, ZoomIn, ZoomOut, X, Trash2 } from "lucide-react";
import toast from "react-hot-toast";
import { comprimirImagenes } from "../../utils/imagenes";

export default function CargaServicio() {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  // Cantidad de tandas de fotos que se están achicando (bloquea el guardado mientras tanto)
  const [procesandoFotos, setProcesandoFotos] = useState(0);

  const [servicio, setServicio] = useState({
    cliente_id: "",
    mod_de_ordeniadora: "",
    ordenios_por_dia: "",
    fecha_servicio: new Date().toISOString().split("T")[0],
    fecha_cambio_pezonera: new Date().toISOString().split("T")[0],
    servicio_prog_cada: "",
    proximo_servicio: "",
    num_de_bajadas: "",
    vida_util_pezonera: "",
    vacas_en_ordenio: "",
    proximo_recambio_pezoneras: "",
    dias_utiles_pezonera: "",
    imagenes_remito: [],
    comentario: "",
  });


  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

  // Estados para el modal de la imagen
  const [imagenModal, setImagenModal] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [rotacion, setRotacion] = useState(0);


  useEffect(() => {
    obtenerClientes();
  }, []);

  const obtenerClientes = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cliente`);
      setClientes(res.data);
    } catch (err) {
      toast.error("❌ Error al cargar clientes");
      console.error(err);
    }
  };

  // 📅 Cálculos automáticos
  useEffect(() => {
    const {
      fecha_servicio,
      fecha_cambio_pezonera,
      servicio_prog_cada,
      vida_util_pezonera,
      num_de_bajadas,
      vacas_en_ordenio,
      ordenios_por_dia,
    } = servicio;

    const fechaValida = fecha_servicio && !isNaN(Date.parse(fecha_servicio));
    const fechaPezoneraValida = fecha_cambio_pezonera && !isNaN(Date.parse(fecha_cambio_pezonera));

    // 🔹 Calcular Próximo Servicio (en meses)
    if (fechaValida && servicio_prog_cada) {
      const nuevaFecha = new Date(fecha_servicio);
      nuevaFecha.setMonth(
        nuevaFecha.getMonth() + Number(servicio_prog_cada)
      );
      setServicio((prev) => ({
        ...prev,
        proximo_servicio: nuevaFecha.toISOString().split("T")[0],
      }));
    }

    // 🔹 Calcular Días útiles y Próximo Recambio de Pezoneras
    if (
      fechaPezoneraValida &&
      vida_util_pezonera &&
      num_de_bajadas &&
      vacas_en_ordenio &&
      ordenios_por_dia
    ) {
      const denominador =
        Number(vacas_en_ordenio) * Number(ordenios_por_dia);

      // ⚠️ Evitar división por cero
      if (denominador > 0) {
        const diasUtiles =
          (Number(vida_util_pezonera) * Number(num_de_bajadas)) /
          denominador;

        const diasRedondeado = Math.round(diasUtiles);
        const fechaRecambio = new Date(fecha_cambio_pezonera);
        fechaRecambio.setDate(fechaRecambio.getDate() + diasRedondeado);

        setServicio((prev) => ({
          ...prev,
          dias_utiles_pezonera: diasRedondeado,
          proximo_recambio_pezoneras: fechaRecambio
            .toISOString()
            .split("T")[0],
        }));
      } else {
        // Si vacas_en_ordenio o ordeños_por_dia son 0, limpiar los campos dependientes
        setServicio((prev) => ({
          ...prev,
          dias_utiles_pezonera: "",
          proximo_recambio_pezoneras: "",
        }));
      }
    }
  }, [
    servicio.fecha_servicio,
    servicio.fecha_cambio_pezonera,
    servicio.servicio_prog_cada,
    servicio.vida_util_pezonera,
    servicio.num_de_bajadas,
    servicio.vacas_en_ordenio,
    servicio.ordenios_por_dia,
  ]);


  // Cambios de input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setServicio({ ...servicio, [name]: value });
  };


  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!servicio.cliente_id) {
  //     toast.error("Debe seleccionar un cliente");
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const formData = new FormData();

  //     // 🔹 Agregar campos normales (NO imágenes)
  //     Object.entries(servicio).forEach(([key, value]) => {
  //       if (key !== "imagenes_remito" && value !== "" && value !== null) {
  //         formData.append(key, value);
  //       }
  //     });

  //     // 🔹 Agregar imágenes (una por una)
  //     if (servicio.imagenes_remito.length > 0) {
  //       servicio.imagenes_remito.forEach((imagen) => {
  //         formData.append("imagenes_remito", imagen);
  //       });
  //     }

  //     await axios.post(
  //       `${process.env.REACT_APP_BASE_URL}/servicio`,
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     toast.success("Servicio cargado correctamente");

  //     // 🔄 Reset formulario
  //     setServicio({
  //       cliente_id: "",
  //       mod_de_ordeniadora: "",
  //       ordenios_por_dia: "",
  //       fecha_servicio: new Date().toISOString().split("T")[0],
  //       fecha_cambio_pezonera: new Date().toISOString().split("T")[0],
  //       servicio_prog_cada: "",
  //       proximo_servicio: "",
  //       num_de_bajadas: "",
  //       vida_util_pezonera: "",
  //       vacas_en_ordenio: "",
  //       proximo_recambio_pezoneras: "",
  //       dias_utiles_pezonera: "",
  //       imagenes_remito: [],
  //       comentario: "",
  //     });

  //     setImagenModal(null);
  //     setZoom(1);
  //     setRotacion(0);

  //   } catch (error) {
  //     console.error("❌ Error al guardar servicio:", error);
  //     toast.error(
  //       error.response?.data?.message || "Error al guardar el servicio"
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  // maneja el cambio de cliente

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!servicio.cliente_id) {
      toast.error("Debe seleccionar un cliente");
      return;
    }

    // Bloqueamos el estado de carga
    setLoading(true);

    const formData = new FormData();

    // 🔹 Agregar campos normales (NO imágenes)
    Object.entries(servicio).forEach(([key, value]) => {
      if (key !== "imagenes_remito" && value !== "" && value !== null) {
        formData.append(key, value);
      }
    });

    // 🔹 Agregar imágenes
    if (servicio.imagenes_remito.length > 0) {
      servicio.imagenes_remito.forEach((imagen) => {
        formData.append("imagenes_remito", imagen);
      });
    }

    // 🚀 La Promesa de Axios
    const promise = axios.post(
      `${process.env.REACT_APP_BASE_URL}/servicio`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    // ⚡ Aplicamos el toast profesional
    toast.promise(
      promise,
      {
        loading: "Subiendo servicio y fotos a la nube...",
        success: (res) => {
          // 🔄 Reset formulario solo si sale bien
          setServicio({
            cliente_id: "",
            mod_de_ordeniadora: "",
            ordenios_por_dia: "",
            fecha_servicio: new Date().toISOString().split("T")[0],
            fecha_cambio_pezonera: new Date().toISOString().split("T")[0],
            servicio_prog_cada: "",
            proximo_servicio: "",
            num_de_bajadas: "",
            vida_util_pezonera: "",
            vacas_en_ordenio: "",
            proximo_recambio_pezoneras: "",
            dias_utiles_pezonera: "",
            imagenes_remito: [],
            comentario: "",
          });
          setImagenModal(null);
          setZoom(1);
          setRotacion(0);
          setLoading(false); // Liberamos el botón
          return "¡Servicio guardado con éxito!";
        },
        error: (err) => {
          setLoading(false); // Liberamos el botón si hay error
          const errorMsg = err.response?.data?.message || "Error al guardar el servicio";
          return <b>{errorMsg}</b>;
        },
      },
      {
        success: {
          duration: 4000,
        },
        error: {
          duration: 5000,
        }
      }
    );
  };

  const handleClienteChange = (e) => {
    const clienteId = e.target.value;
    const cliente = clientes.find((c) => String(c.id) === String(clienteId));
    setClienteSeleccionado(cliente || null);

    setServicio((prev) => ({
      ...prev,
      cliente_id: clienteId,
      mod_de_ordeniadora: cliente?.descripcion_ordeniadora || "",
    }));
  };

  // esto es para agregar otra imagen
  const agregarImagenes = async (files) => {
    if (!files || files.length === 0) return;

    // Achicamos las fotos antes de agregarlas (subida mucho más rápida desde el campo)
    const lista = Array.from(files);
    setProcesandoFotos((n) => n + 1);
    try {
      const comprimidas = await comprimirImagenes(lista);
      setServicio((prev) => ({
        ...prev,
        imagenes_remito: [...prev.imagenes_remito, ...comprimidas],
      }));
    } finally {
      setProcesandoFotos((n) => n - 1);
    }
  };



  // 🎨 Estilos de la interfaz (solo visual)
  const labelCls = "block text-[10px] font-bold text-slate-600 uppercase tracking-wide mb-0.5";
  const inputCls = "w-full h-8 border border-slate-300 rounded-md px-2.5 text-[12px] text-slate-900 bg-white outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all";
  const readCls = "w-full h-8 border border-blue-100 rounded-md px-2.5 text-[12px] font-bold text-blue-900 bg-blue-50/60 outline-none cursor-default";
  const tituloSeccion = "text-[11px] font-black text-blue-700 uppercase tracking-[0.15em] mb-2 flex items-center gap-2 after:flex-1 after:h-px after:bg-slate-100";

  return (

    <div className="h-full flex flex-col">
      <form
        onSubmit={handleSubmit}
        className="flex-1 min-h-0 flex flex-col bg-white shadow-sm border border-slate-200 rounded-xl overflow-hidden"
      >
        <div className="flex-1 min-h-0 overflow-y-auto scroll-fino p-3 lg:p-4 space-y-3.5">

          {/* ── CLIENTE Y FECHAS ── */}
          <section>
            <h4 className={tituloSeccion}>Cliente y fechas</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
              {/* Cliente */}
              <div className="md:col-span-2">
                <label className={labelCls}>Cliente <span className="text-red-500">*</span></label>
                <select
                  name="cliente_id"
                  value={servicio.cliente_id}
                  onChange={handleClienteChange}
                  className={inputCls}
                  required
                >
                  <option value="">Seleccionar cliente...</option>
                  {clientes.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nombre}
                    </option>
                  ))}
                </select>
              </div>

              {/* Modelo ordeñadora */}
              <div className="md:col-span-2">
                <label className={labelCls}>Modelo de ordeñadora</label>
                <input
                  type="text"
                  readOnly
                  name="mod_de_ordeniadora"
                  required
                  autoComplete="off"
                  placeholder="Se completa al elegir el cliente"
                  value={servicio.mod_de_ordeniadora}
                  onChange={handleChange}
                  title={servicio.mod_de_ordeniadora}
                  className="w-full h-8 border border-slate-200 rounded-md px-2.5 text-[12px] bg-slate-100 text-slate-600 cursor-not-allowed truncate"
                />
              </div>

              {/* Fecha de servicio */}
              <div>
                <label className={labelCls}>Fecha último servicio técnico <span className="text-red-500">*</span></label>
                <input
                  type="date"
                  name="fecha_servicio"
                  value={servicio.fecha_servicio}
                  onChange={(e) => {
                    // Si cambia el servicio, sugerimos la misma fecha para pezoneras por comodidad
                    const val = e.target.value;
                    setServicio(prev => ({ ...prev, fecha_servicio: val, fecha_cambio_pezonera: val }));
                  }}
                  className={inputCls}
                  required
                />
              </div>

              {/* Fecha de cambio de pezoneras */}
              <div>
                <label className={labelCls}>Fecha último cambio de pezoneras <span className="text-red-500">*</span></label>
                <input
                  type="date"
                  name="fecha_cambio_pezonera"
                  value={servicio.fecha_cambio_pezonera}
                  onChange={handleChange}
                  className={inputCls}
                  required
                />
              </div>

              {/* Servicio programado */}
              <div>
                <label className={labelCls}>Servicio programado cada (meses)</label>
                <input
                  type="number"
                  name="servicio_prog_cada"
                  value={servicio.servicio_prog_cada}
                  onChange={handleChange}
                  className={inputCls}
                />
              </div>

              {/* Ordeños por día */}
              <div>
                <label className={labelCls}>Ordeños por día</label>
                <input
                  type="number"
                  name="ordenios_por_dia"
                  value={servicio.ordenios_por_dia}
                  onChange={handleChange}
                  className={inputCls}
                />
              </div>
            </div>
          </section>

          {/* ── DATOS DEL TAMBO + CÁLCULOS ── */}
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
            <section>
              <h4 className={tituloSeccion}>Datos del tambo</h4>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {/* Nº de bajadas */}
                <div>
                  <label className={labelCls}>Puestos de ordeñe</label>
                  <input
                    type="number"
                    name="num_de_bajadas"
                    value={servicio.num_de_bajadas}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>

                {/* Vida útil de pezonera */}
                <div>
                  <label className={labelCls}>Vida útil pezonera</label>
                  <input
                    type="number"
                    name="vida_util_pezonera"
                    value={servicio.vida_util_pezonera}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>

                {/* Vacas en ordeño */}
                <div>
                  <label className={labelCls}>Vacas en ordeño</label>
                  <input
                    type="number"
                    name="vacas_en_ordenio"
                    value={servicio.vacas_en_ordenio}
                    onChange={handleChange}
                    className={inputCls}
                  />
                </div>
              </div>
            </section>

            <section>
              <h4 className={tituloSeccion}>Cálculos automáticos</h4>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {/* Próximo servicio */}
                <div>
                  <label className={labelCls}>Próximo servicio técnico</label>
                  <input
                    type="date"
                    name="proximo_servicio"
                    value={servicio.proximo_servicio}
                    readOnly
                    className={readCls}
                  />
                </div>

                {/* Próximo recambio */}
                <div>
                  <label className={labelCls}>Próximo cambio pezoneras</label>
                  <input
                    type="date"
                    name="proximo_recambio_pezoneras"
                    value={servicio.proximo_recambio_pezoneras}
                    readOnly
                    className={readCls}
                  />
                </div>

                {/* Días útiles de pezonera */}
                <div>
                  <label className={labelCls}>Días útiles pezonera</label>
                  <input
                    type="text"
                    name="dias_utiles_pezonera"
                    value={servicio.dias_utiles_pezonera}
                    readOnly
                    className={readCls}
                  />
                </div>
              </div>
            </section>
          </div>

          {/* ── COMENTARIO Y REMITO ── */}
          <section>
            <h4 className={tituloSeccion}>Comentario y remito</h4>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-3">
              {/* Comentario */}
              <div className="flex flex-col">
                <label className={labelCls}>Comentario</label>
                <textarea
                  name="comentario"
                  value={servicio.comentario}
                  onChange={handleChange}
                  rows={4}
                  placeholder="Observaciones del servicio..."
                  className="w-full flex-1 min-h-[84px] border border-slate-300 rounded-md p-2 text-[12px] outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
                />
              </div>

              {/* 📷 Carga de imágenes */}
              <div className="flex flex-col">
                <label className={labelCls}>
                  Fotos del remito
                  {procesandoFotos > 0 && (
                    <span className="ml-2 inline-flex items-center gap-1 text-blue-600 normal-case tracking-normal">
                      <Loader2 className="animate-spin" size={12} /> procesando...
                    </span>
                  )}
                </label>
                {servicio.imagenes_remito.length === 0 ? (
                  /* Primera carga */
                  <label className="flex-1 min-h-[84px] cursor-pointer flex flex-col items-center justify-center border-2 border-dashed border-slate-300 rounded-lg p-4 hover:bg-blue-50/50 hover:border-blue-400 transition">
                    <Camera size={32} className="text-blue-600 mb-1" />
                    <span className="text-blue-700 text-[12px] font-semibold">Tomar o subir fotos</span>
                    <input
                      type="file"
                      accept="image/*;capture=camera"
                      multiple
                      onChange={(e) => agregarImagenes(e.target.files)}
                      className="hidden"
                    />
                  </label>
                ) : (
                  <div className="flex-1 min-h-[84px] border border-slate-200 rounded-lg p-2">
                    {/* Miniaturas */}
                    <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">
                      {servicio.imagenes_remito.map((img, index) => (
                        <div key={index} className="relative border border-slate-200 rounded-md h-[72px] bg-slate-50">
                          <img
                            src={URL.createObjectURL(img)}
                            alt="Remito"
                            className="object-contain w-full h-full cursor-pointer"
                            onClick={() => {
                              setImagenModal(URL.createObjectURL(img));
                              setZoom(1);
                              setRotacion(0);
                            }}
                          />

                          {/* ❌ Eliminar imagen */}
                          <button
                            type="button"
                            onClick={() =>
                              setServicio((prev) => ({
                                ...prev,
                                imagenes_remito: prev.imagenes_remito.filter(
                                  (_, i) => i !== index
                                ),
                              }))
                            }
                            className="absolute -top-1.5 -right-1.5 bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center shadow"
                          >
                            <X size={12} />
                          </button>
                        </div>
                      ))}

                      {/* ➕ Cargar otra */}
                      <label
                        title="Cargar otra imagen"
                        className="h-[72px] cursor-pointer flex flex-col items-center justify-center border-2 border-dashed border-slate-300 rounded-md text-blue-600 hover:bg-blue-50 hover:border-blue-400 transition"
                      >
                        <Camera size={18} />
                        <span className="text-[9px] font-bold uppercase mt-0.5">Agregar</span>
                        <input
                          type="file"
                          accept="image/*;capture=camera"
                          multiple
                          onChange={(e) => agregarImagenes(e.target.files)}
                          className="hidden"
                        />
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>

        {/* Botón Guardar (siempre visible) */}
        <div className="shrink-0 border-t border-slate-200 bg-slate-50 px-4 py-2 flex items-center justify-between gap-3">
          <p className="hidden md:block text-[11px] text-slate-400 font-medium">
            Las fechas próximas se calculan solas y se agendan en Google Calendar.
          </p>
          <button
            type="submit"
            disabled={loading || procesandoFotos > 0}
            className={`w-full md:w-48 flex justify-center items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white h-8 rounded-lg text-[12px] font-bold shadow-md shadow-blue-200 transition active:scale-[0.98] ${loading || procesandoFotos > 0 ? "opacity-70 cursor-not-allowed" : ""}`}
          >
            {loading ? (
              <>
                <Loader2 className="animate-spin" size={18} />
                Guardando...
              </>
            ) : procesandoFotos > 0 ? (
              <>
                <Loader2 className="animate-spin" size={18} />
                Procesando fotos...
              </>
            ) : (
              "GUARDAR SERVICIO"
            )}
          </button>
        </div>
      </form>

      {/* 🪟 Modal de visualización */}
      {imagenModal && (
        <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-[100]">

          <div className="relative flex flex-col items-center">
            {/* Controles */}
            <div className="flex gap-3 mb-4 bg-white p-2 rounded-lg shadow-md items-center">
              <button
                type="button"
                onClick={() => setRotacion((r) => r + 90)}
                className="p-2 rounded hover:bg-gray-100"
                title="Rotar 90°"
              >
                <RotateCw size={20} className="text-blue-600" />
              </button>

              <button
                type="button"
                onClick={() => setZoom((z) => Math.min(z + 0.2, 3))}
                className="p-2 rounded hover:bg-gray-100"
                title="Acercar"
              >
                <ZoomIn size={20} className="text-gray-700" />
              </button>

              <button
                type="button"
                onClick={() => setZoom((z) => Math.max(z - 0.2, 0.5))}
                className="p-2 rounded hover:bg-gray-100"
                title="Alejar"
              >
                <ZoomOut size={20} className="text-gray-700" />
              </button>

              <button
                type="button"
                onClick={() => setImagenModal(null)}
                className="p-2 rounded hover:bg-gray-100"
                title="Cerrar"
              >
                <X size={20} className="text-gray-700" />
              </button>
            </div>

            {/* Imagen ampliada */}
            <div className="max-w-[90vw] max-h-[80vh] overflow-hidden flex justify-center items-center">
              <img
                src={imagenModal}
                alt="Vista previa del remito"
                className="rounded-lg shadow-lg transition-transform duration-200"
                style={{
                  transform: `scale(${zoom}) rotate(${rotacion}deg)`,
                  transformOrigin: "center center",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>

  );
}
